import Select from "components/controls/Select";
import React from "react";

export default function LineSelect({ lines, disabled = false }) {
  const options = toOptions(lines);

  return (
    <Select
      className="spec-line-select"
      disabled={disabled}
      field="line[id]"
      labelText="Line"
      maxHeight="250"
      options={options}
    />
  );
}

function toOptions(lines) {
  return lines.map(({ name, id }) => ({ label: name, value: id }));
}
